// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"134":"9437d457","370":"3de88519","700":"99e37636","701":"852ce526","916":"0dcbd679"}[chunkId] + ".css";
};